import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchPlaybook = createAction(constants.FETCH_PLAYBOOK)
export const fetchPlaybookPending = createAction(constants.FETCH_PLAYBOOK_PENDING)
export const fetchPlaybookCancelled = createAction(constants.FETCH_PLAYBOOK_CANCELLED)
export const fetchPlaybookFailed = createAction(constants.FETCH_PLAYBOOK_FAILED)

export const getPlaybook = createAction(constants.GET_PLAYBOOK)
export const getPlaybookPending = createAction(constants.GET_PLAYBOOK_PENDING)
export const getPlaybookCancelled = createAction(constants.GET_PLAYBOOK_CANCELLED)
export const getPlaybookFailed = createAction(constants.GET_PLAYBOOK_FAILED)
export const getPlaybookSuccess = createAction(constants.GET_PLAYBOOK_SUCCESS)

export const fetchPlaybookCounts = createAction(constants.FETCH_PLAYBOOK_COUNTS)
export const fetchPlaybookCountsPending = createAction(constants.FETCH_PLAYBOOK_COUNTS_PENDING)
export const fetchPlaybookCountsCancelled = createAction(constants.FETCH_PLAYBOOK_COUNTS_CANCELLED)
export const fetchPlaybookCountsSuccess = createAction(constants.FETCH_PLAYBOOK_COUNTS_SUCCESS)
export const fetchPlaybookCountsFailed = createAction(constants.FETCH_PLAYBOOK_COUNTS_FAILED)

export const fetchPlaybookCardinality = createAction(constants.FETCH_PLAYBOOK_CARDINALITY)
export const fetchPlaybookCardinalityPending = createAction(constants.FETCH_PLAYBOOK_CARDINALITY_PENDING)
export const fetchPlaybookCardinalitySuccess = createAction(constants.FETCH_PLAYBOOK_CARDINALITY_SUCCESS)
export const fetchPlaybookCardinalityFailed = createAction(constants.FETCH_PLAYBOOK_CARDINALITY_FAILED)
export const fetchPlaybookCardinalityCancelled = createAction(constants.FETCH_PLAYBOOK_CARDINALITY_CANCELLED)

export const fetchPlaybookByCampaignId = createAction(constants.FETCH_PLAYBOOK_BY_CAMPAIGN_ID)
export const fetchPlaybookByCampaignIdPending = createAction(constants.FETCH_PLAYBOOK_BY_CAMPAIGN_ID_PENDING)
export const fetchPlaybookByCampaignIdCancelled = createAction(
  constants.FETCH_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED
)
export const fetchPlaybookByCampaignIdFailed = createAction(constants.FETCH_PLAYBOOK_BY_CAMPAIGN_ID_FAILED)
export const fetchPlaybookByCampaignIdSuccess = createAction(constants.FETCH_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS)

export const getPlaybookByCampaignId = createAction(constants.GET_PLAYBOOK_BY_CAMPAIGN_ID)
export const getPlaybookByCampaignIdPending = createAction(constants.GET_PLAYBOOK_BY_CAMPAIGN_ID_PENDING)
export const getPlaybookByCampaignIdCancelled = createAction(constants.GET_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED)
export const getPlaybookByCampaignIdFailed = createAction(constants.GET_PLAYBOOK_BY_CAMPAIGN_ID_FAILED)
export const getPlaybookByCampaignIdSuccess = createAction(constants.GET_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS)

export const fetchPlaybookByInteractionId = createAction(constants.FETCH_PLAYBOOK_BY_INTERACTION_ID)
export const fetchPlaybookByInteractionIdPending = createAction(
  constants.FETCH_PLAYBOOK_BY_INTERACTION_ID_PENDING
)
export const fetchPlaybookByInteractionIdCancelled = createAction(
  constants.FETCH_PLAYBOOK_BY_INTERACTION_ID_CANCELLED
)
export const fetchPlaybookByInteractionIdFailed = createAction(
  constants.FETCH_PLAYBOOK_BY_INTERACTION_ID_FAILED
)
export const fetchPlaybookByInteractionIdSuccess = createAction(
  constants.FETCH_PLAYBOOK_BY_INTERACTION_ID_SUCCESS
)

export const createPlaybook = createAction(constants.CREATE_PLAYBOOK)
export const createPlaybookPending = createAction(constants.CREATE_PLAYBOOK_PENDING)
export const createPlaybookCancelled = createAction(constants.CREATE_PLAYBOOK_CANCELLED)
export const createPlaybookFailed = createAction(constants.CREATE_PLAYBOOK_FAILED)

export const clonePlaybook = createAction(constants.CLONE_PLAYBOOK)
export const clonePlaybookPending = createAction(constants.CLONE_PLAYBOOK_PENDING)
export const clonePlaybookCancelled = createAction(constants.CLONE_PLAYBOOK_CANCELLED)
export const clonePlaybookFailed = createAction(constants.CLONE_PLAYBOOK_FAILED)
export const clonePlaybookSuccess = createAction(constants.CLONE_PLAYBOOK_SUCCESS)

export const sendTestEmail = createAction(constants.SEND_TEST_EMAIL)
export const sendTestEmailPending = createAction(constants.SEND_TEST_EMAIL_PENDING)
export const sendTestEmailSuccess = createAction(constants.SEND_TEST_EMAIL_SUCCESS)
export const sendTestEmailFailed = createAction(constants.SEND_TEST_EMAIL_FAILED)

export const sendTestSequence = createAction(constants.SEND_TEST_SEQUENCE)
export const sendTestSequencePending = createAction(constants.SEND_TEST_SEQUENCE_PENDING)
export const sendTestSequenceFailed = createAction(constants.SEND_TEST_SEQUENCE_FAILED)
export const sendTestSequenceCancelled = createAction(constants.SEND_TEST_SEQUENCE_CANCELLED)
export const sendTestSequenceSuccess = createAction(constants.SEND_TEST_SEQUENCE_SUCCESS)

export const searchEnabledPlaybooks = createAction(constants.SEARCH_ENABLED_PLAYBOOKS)
export const searchPlaybooks = createAction(constants.SEARCH_PLAYBOOKS)
export const searchPlaybooksPending = createAction(constants.SEARCH_PLAYBOOKS_PENDING)
export const searchPlaybooksCancelled = createAction(constants.SEARCH_PLAYBOOKS_CANCELLED)
export const searchPlaybooksFailed = createAction(constants.SEARCH_PLAYBOOKS_FAILED)
export const searchPlaybooksSuccess = createAction(constants.SEARCH_PLAYBOOKS_SUCCESS)

export const savePlaybook = createAction(constants.SAVE_PLAYBOOK)
export const savePlaybookPending = createAction(constants.SAVE_PLAYBOOK_PENDING)
export const savePlaybookCancelled = createAction(constants.SAVE_PLAYBOOK_CANCELLED)
export const savePlaybookSuccess = createAction(constants.SAVE_PLAYBOOK_SUCCESS)
export const savePlaybookFailed = createAction(constants.SAVE_PLAYBOOK_DRAFT_FAILED)

export const setStatus = createAction(constants.SET_STATUS)

export const savePlaybookDraft = createAction(constants.SAVE_PLAYBOOK_DRAFT)
export const savePlaybookDraftPending = createAction(constants.SAVE_PLAYBOOK_DRAFT_PENDING)
export const savePlaybookDraftCancelled = createAction(constants.SAVE_PLAYBOOK_DRAFT_CANCELLED)
export const savePlaybookDraftFailed = createAction(constants.SAVE_PLAYBOOK_DRAFT_FAILED)

export const schedulePlaybookDraft = createAction(constants.SCHEDULE_PLAYBOOK_DRAFT)

export const receivePlaybookDraft = createAction(constants.RECEIVE_PLAYBOOK_DRAFT)
export const acceptPlaybookDraft = createAction(constants.ACCEPT_PLAYBOOK_DRAFT)
export const clearDraft = createAction(constants.CLEAR_DRAFT)

export const enablePlaybookAutosave = createAction(constants.ENABLE_PLAYBOOK_AUTOSAVE)
export const disablePlaybookAutosave = createAction(constants.DISABLE_PLAYBOOK_AUTOSAVE)
export const markDraftUnsaved = createAction(constants.MARK_DRAFT_UNSAVED)

export const setDraftStatus = createAction(constants.SET_DRAFT_STATUS)
export const setDraftStatusPending = createAction(constants.SET_DRAFT_STATUS_PENDING)
export const setDraftStatusCancelled = createAction(constants.SET_DRAFT_STATUS_CANCELLED)
export const setDraftStatusSuccess = createAction(constants.SET_DRAFT_STATUS_SUCCESS)
export const setDraftStatusFailed = createAction(constants.SET_DRAFT_STATUS_DRAFT_FAILED)

export const setName = createAction(constants.SET_NAME)
export const setSlug = createAction(constants.SET_SLUG)

export const setSequenceDynamicAccountSendAttribute = createAction(
  constants.SET_SEQUENCE_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE
)
export const setSequenceDynamicSenderFormat = createAction(constants.SET_SEQUENCE_DYNAMIC_SENDER_FORMAT)
export const setSequenceEmailOverride = createAction(constants.SET_SEQUENCE_EMAIL_OVERRIDE)
export const setSequenceSenderName = createAction(constants.SET_SEQUENCE_SENDER_NAME)
export const setSequenceIndividualEmailOverride = createAction(
  constants.SET_SEQUENCE_INDIVIDUAL_EMAIL_OVERRIDE
)
export const setSequenceIndividualSenderName = createAction(constants.SET_SEQUENCE_INDIVIDUAL_SENDER_NAME)
export const setSequenceIndividualDynamicAttr = createAction(constants.SET_SEQUENCE_INDIVIDUAL_DYNAMIC_ATTR)
export const setSequenceIndividualDynamicFormat = createAction(
  constants.SET_SEQUENCE_INDIVIDUAL_DYNAMIC_FORMAT
)
export const setDynamicAccountSendAttribute = createAction(constants.SET_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE)
export const setDynamicSenderFormat = createAction(constants.SET_DYNAMIC_SENDER_FORMAT)
export const setEmailOverride = createAction(constants.SET_EMAIL_OVERRIDE)
export const setSenderName = createAction(constants.SET_SENDER_NAME)
export const setMessage = createAction(constants.SET_MESSAGE)
export const setVideoUrl = createAction(constants.SET_VIDEO_URL)
export const setHeadline = createAction(constants.SET_HEADLINE)
export const setThankYouMessage = createAction(constants.SET_THANK_YOU_MESSAGE)
export const setThankYouHeadline = createAction(constants.SET_THANK_YOU_HEADLINE)
export const setCtaType = createAction(constants.SET_CTA_TYPE)
export const setCtaLink = createAction(constants.SET_CTA_LINK)
export const setCtaCopy = createAction(constants.SET_CTA_COPY)
export const setSequenceAuthorId = createAction(constants.SET_SEQUENCE_AUTHOR_ID)
export const setAuthorId = createAction(constants.SET_AUTHOR_ID)
export const setEmailTheme = createAction(constants.SET_EMAIL_THEME)

export const setEmailTitle = createAction(constants.SET_EMAIL_TITLE)
export const setEmailMessage = createAction(constants.SET_EMAIL_MESSAGE)
export const setEmailDelay = createAction(constants.SET_EMAIL_DELAY)
export const addEmail = createAction(constants.ADD_EMAIL)
export const deleteEmail = createAction(constants.DELETE_EMAIL)
export const moveEmailUp = createAction(constants.MOVE_EMAIL_UP)
export const setWeekdaysOnly = createAction(constants.SET_WEEKDAYS_ONLY)
export const setSmartSending = createAction(constants.SET_SMART_SENDING)
export const setUnenrollOnReply = createAction(constants.SET_UNENROLL_ON_REPLY)
export const setUnenrollOnReplyByDomain = createAction(constants.SET_UNENROLL_ON_REPLY_BY_DOMAIN)
export const setThreadedWithPrevious = createAction(constants.SET_THREADED_WITH_PREVIOUS)

export const setGreeting = createAction(constants.SET_GREETING)
export const setQuestionPrompt = createAction(constants.SET_QUESTION_PROMPT)
export const setSkipTo = createAction(constants.SET_SKIP_TO)
export const setGoalClassification = createAction(constants.SET_GOAL_CLASSIFICATION)
export const setGoalMessage = createAction(constants.SET_GOAL_MESSAGE)
export const setKeywordText = createAction(constants.SET_KEYWORD_TEXT)
export const setKeywordType = createAction(constants.SET_KEYWORD_TYPE)
export const setAnswerType = createAction(constants.SET_ANSWER_TYPE)
export const setButtonText = createAction(constants.SET_BUTTON_TEXT)
export const setResponse = createAction(constants.SET_RESPONSE)
export const setDefaultPhoneCountryCode = createAction(constants.SET_DEFAULT_PHONE_COUNTRY_CODE)
export const setFieldAttributeName = createAction(constants.SET_FIELD_ATTRIBUTE_NAME)
export const setButtonOnlyResponses = createAction(constants.SET_BUTTON_ONLY_RESPONSES)
export const addGoal = createAction(constants.ADD_GOAL)
export const addQuestion = createAction(constants.ADD_QUESTION)
export const addKeyword = createAction(constants.ADD_KEYWORD)
export const addAnswer = createAction(constants.ADD_ANSWER)
export const addEmailCaptureQuestion = createAction(constants.ADD_EMAIL_CAPTURE_QUESTION)
export const addPhoneCaptureQuestion = createAction(constants.ADD_PHONE_CAPTURE_QUESTION)
export const deleteQuestion = createAction(constants.DELETE_QUESTION)
export const deleteAnswer = createAction(constants.DELETE_ANSWER)
export const deleteGoal = createAction(constants.DELETE_GOAL)
export const deleteKeyword = createAction(constants.DELETE_KEYWORD)
export const flagAnswer = createAction(constants.FLAG_ANSWER)
export const moveQuestionUp = createAction(constants.MOVE_QUESTION_UP)
export const saveGoalAction = createAction(constants.SAVE_GOAL_ACTION)
export const saveGoalRoutingOption = createAction(constants.SAVE_GOAL_ROUTING_OPTION)

export const setActionInboxId = createAction(constants.SET_ACTION_INBOX_ID)

export const setCurrentGoalId = createAction(constants.SET_CURRENT_GOAL_ID)
export const selectGoalRoutingOptionUI = createAction(constants.SET_GOAL_ROUTING_OPTION)
export const setGoalRoutingView = createAction(constants.SET_GOAL_ROUTING_VIEW)
export const selectGoalAction = createAction(constants.SELECT_GOAL_ACTION)
export const removeGoalAction = createAction(constants.REMOVE_GOAL_ACTION)

export const showSendEmailConfirmModal = createAction(constants.SHOW_SEND_EMAIL_CONFIRM_MODAL)
export const hideSendEmailConfirmModal = createAction(constants.HIDE_SEND_EMAIL_CONFIRM_MODAL)
export const showEditSenderModal = createAction(constants.SHOW_EDIT_SENDER_MODAL)
export const hideEditSenderModal = createAction(constants.HIDE_EDIT_SENDER_MODAL)
export const showCalendarLinkModal = createAction(constants.SHOW_CALENDAR_LINK_MODAL)
export const hideCalendarLinkModal = createAction(constants.HIDE_CALENDAR_LINK_MODAL)
export const showTokenModal = createAction(constants.SHOW_TOKEN_MODAL)
export const hideTokenModal = createAction(constants.HIDE_TOKEN_MODAL)
export const showCtaButtonModal = createAction(constants.SHOW_CTA_BUTTON_MODAL)
export const hideCtaButtonModal = createAction(constants.HIDE_CTA_BUTTON_MODAL)
export const showExtensionInviteModal = createAction(constants.SHOW_EXTENSION_INVITE_MODAL)
export const hideExtensionInviteModal = createAction(constants.HIDE_EXTENSION_INVITE_MODAL)
export const showGoalActionModal = createAction(constants.SHOW_GOAL_ACTION_MODAL)
export const hideGoalActionModal = createAction(constants.HIDE_GOAL_ACTION_MODAL)
export const showGoalRoutingModal = createAction(constants.SHOW_GOAL_ROUTING_MODAL)
export const hideGoalRoutingModal = createAction(constants.HIDE_GOAL_ROUTING_MODAL)
export const showAnswerModal = createAction(constants.SHOW_ANSWER_MODAL)
export const hideAnswerModal = createAction(constants.HIDE_ANSWER_MODAL)
export const showQuestionAdvancedModal = createAction(constants.SHOW_QUESTION_ADVANCED_MODAL)
export const hideQuestionAdvancedModal = createAction(constants.HIDE_QUESTION_ADVANCED_MODAL)
export const showConditionModal = createAction(constants.SHOW_CONDITION_MODAL)
export const hideConditionModal = createAction(constants.HIDE_CONDITION_MODAL)
export const showScheduleModal = createAction(constants.SHOW_SCHEDULE_MODAL)
export const hideScheduleModal = createAction(constants.HIDE_SCHEDULE_MODAL)
export const showSequenceInviteModal = createAction(constants.SHOW_SEQUENCE_INVITE_MODAL)
export const hideSequenceInviteModal = createAction(constants.HIDE_SEQUENCE_INVITE_MODAL)
export const showGoogleAuthModal = createAction(constants.SHOW_GOOGLE_AUTH_MODAL)
export const hideGoogleAuthModal = createAction(constants.HIDE_GOOGLE_AUTH_MODAL)
export const setMarketingEmailLayout = createAction(constants.SET_MARKETING_EMAIL_LAYOUT)
export const showDisableSalesSequenceModal = createAction(constants.SHOW_DISABLE_SALES_SEQUENCE_MODAL)
export const hideDisableSalesSequenceModal = createAction(constants.HIDE_DISABLE_SALES_SEQUENCE_MODAL)

export const resetDisplayConditions = createAction(constants.RESET_DISPLAY_CONDITIONS)
export const setEmailPlaybookConditionValue = createAction(constants.SET_EMAIL_PLAYBOOK_CONDITION_VALUE)
export const setConditionValue = createAction(constants.SET_CONDITION_VALUE)
export const setConditionField = createAction(constants.SET_CONDITION_FIELD)
export const setConditionOperator = createAction(constants.SET_CONDITION_OPERATOR)
export const deleteCondition = createAction(constants.DELETE_CONDITION)
export const addCondition = createAction(constants.ADD_CONDITION)
export const deleteConditionSet = createAction(constants.DELETE_CONDITION_SET)
export const addConditionSet = createAction(constants.ADD_CONDITION_SET)

export const setAudience = createAction(constants.SET_AUDIENCE)
export const setDraftSchedule = createAction(constants.SET_DRAFT_SCHEDULE)
export const setExcludedUserListIds = createAction(constants.SET_EXCLUDED_USER_LIST_IDS)
export const setUserListIds = createAction(constants.SET_USER_LIST_IDS)
export const setExcludedAccountListIds = createAction(constants.SET_EXCLUDED_ACCOUNT_LIST_IDS)
export const setAccountListIds = createAction(constants.SET_ACCOUNT_LIST_IDS)
export const setSmartFilterEngagedContacts = createAction(constants.SET_SMART_FILTERS_ENGAGED_CONTACTS)
export const setSmartFilterChatEngagedContacts = createAction(
  constants.SET_SMART_FILTERS_CHAT_ENGAGED_CONTACTS
)
export const setSmartFilters = createAction(constants.SET_SMART_FILTERS)

export const fetchPlaybooksPriority = createAction(constants.FETCH_PLAYBOOKS_PRIORITY)
export const fetchPlaybooksPriorityPending = createAction(constants.FETCH_PLAYBOOKS_PRIORITY_PENDING)
export const fetchPlaybooksPriorityCancelled = createAction(constants.FETCH_PLAYBOOKS_PRIORITY_CANCELLED)
export const fetchPlaybooksPriorityFailed = createAction(constants.FETCH_PLAYBOOKS_PRIORITY_FAILED)
export const fetchPlaybooksPrioritySuccess = createAction(constants.FETCH_PLAYBOOKS_PRIORITY_SUCCESS)

export const setMetaAttribute = createAction(constants.SET_META_ATTRIBUTE)

export const hideSegmentSelect = createAction(constants.HIDE_SEGMENT_SELECT)
export const showSegmentSelect = createAction(constants.SHOW_SEGMENT_SELECT)

export const setDraftFrequency = createAction(constants.SET_DRAFT_FREQUENCY)
export const disablePlaybook = createAction(constants.DISABLE_PLAYBOOK)
export const allChanges = createAction(constants.ALL_CHANGES)

export const fetchDataPreviewEmail = createAction(constants.FETCH_DATA_PREVIEW_EMAIL)
export const fetchDataPreviewEmailPending = createAction(constants.FETCH_DATA_PREVIEW_EMAIL_PENDING)
export const fetchDataPreviewEmailCancelled = createAction(constants.FETCH_DATA_PREVIEW_EMAIL_CANCELLED)
export const fetchDataPreviewEmailFailed = createAction(constants.FETCH_DATA_PREVIEW_EMAIL_FAILED)
export const fetchDataPreviewEmailSuccess = createAction(constants.FETCH_DATA_PREVIEW_EMAIL_SUCCESS)

export const fetchDataPreviewSequenceEmail = createAction(constants.FETCH_DATA_PREVIEW_SEQUENCE_EMAIL)
export const fetchDataPreviewSequenceEmailPending = createAction(
  constants.FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_PENDING
)
export const fetchDataPreviewSequenceEmailCancelled = createAction(
  constants.FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_CANCELLED
)
export const fetchDataPreviewSequenceEmailFailed = createAction(
  constants.FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_FAILED
)
export const fetchDataPreviewSequenceEmailSuccess = createAction(
  constants.FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_SUCCESS
)

export const enroll = createAction(constants.ENROLL)
export const enrollPending = createAction(constants.ENROLL_PENDING)
export const enrollFailed = createAction(constants.ENROLL_FAILED)
export const enrollSuccess = createAction(constants.ENROLL_SUCCESS)

export const unenroll = createAction(constants.UNENROLL)
export const unenrollPending = createAction(constants.UNENROLL_PENDING)
export const unenrollFailed = createAction(constants.UNENROLL_FAILED)
export const unenrollSuccess = createAction(constants.UNENROLL_SUCCESS)

export const notify = createAction(constants.NOTIFY)
export const notifyPending = createAction(constants.NOTIFY_PENDING)
export const notifyFailed = createAction(constants.NOTIFY_FAILED)
export const notifySuccess = createAction(constants.NOTIFY_SUCCESS)

export const fetchPlaybooksByIds = createAction(constants.FETCH_PLAYBOOKS_BY_IDS)
export const fetchPlaybooksByIdsSuccess = createAction(constants.FETCH_PLAYBOOKS_BY_IDS_SUCCESS)
export const fetchPlaybooksByIdsPending = createAction(constants.FETCH_PLAYBOOKS_BY_IDS_PENDING)
export const fetchPlaybooksByIdsFailed = createAction(constants.FETCH_PLAYBOOKS_BY_IDS_FAILED)

export const fetchEnrolledPlaybookId = createAction(constants.FETCH_ENROLLED_PLAYBOOK_ID)
export const fetchEnrolledPlaybookIdSuccess = createAction(constants.FETCH_ENROLLED_PLAYBOOK_ID_SUCCESS)
export const fetchEnrolledPlaybookIdPending = createAction(constants.FETCH_ENROLLED_PLAYBOOK_ID_PENDING)
export const fetchEnrolledPlaybookIdFailed = createAction(constants.FETCH_ENROLLED_PLAYBOOK_ID_FAILED)

export const fetchEnrolledSequenceCount = createAction(constants.FETCH_ENROLLED_SEQUENCE_COUNT)
export const fetchEnrolledSequenceCountSuccess = createAction(constants.FETCH_ENROLLED_SEQUENCE_COUNT_SUCCESS)
export const fetchEnrolledSequenceCountPending = createAction(constants.FETCH_ENROLLED_SEQUENCE_COUNT_PENDING)
export const fetchEnrolledSequenceCountFailed = createAction(constants.FETCH_ENROLLED_SEQUENCE_COUNT_FAILED)

export const fetchPlaybookForEndUser = createAction(constants.FETCH_PLAYBOOK_FOR_END_USER)
export const fetchPlaybookForEndUserSuccess = createAction(constants.FETCH_PLAYBOOK_FOR_END_USER_SUCCESS)
export const fetchPlaybookForEndUserPending = createAction(constants.FETCH_PLAYBOOK_FOR_END_USER_PENDING)
export const fetchPlaybookForEndUserFailed = createAction(constants.FETCH_PLAYBOOK_FOR_END_USER_FAILED)

export const setPlaybookForEndUserSubject = createAction(constants.SET_PLAYBOOK_FOR_END_USER_SUBJECT)
export const setPlaybookForEndUserMessage = createAction(constants.SET_PLAYBOOK_FOR_END_USER_MESSAGE)
export const setPlaybookForEndUserDelay = createAction(constants.SET_PLAYBOOK_FOR_END_USER_DELAY)

export const clearEnrollModalState = createAction(constants.CLEAR_ENROLL_MODAL_STATE)

export const clearEmailBanner = createAction(constants.CLEAR_EMAIL_BANNER)
export const setEmailBanner = createAction(constants.SET_EMAIL_BANNER)
export const setEmailBannerSuccess = createAction(constants.SET_EMAIL_BANNER_SUCCESS)
export const setEmailBannerFailed = createAction(constants.SET_EMAIL_BANNER_FAILED)
export const setEmailBannerPending = createAction(constants.SET_EMAIL_BANNER_PENDING)

export const fetchPlaybooksByGatedPlan = createAction(constants.FETCH_PLAYBOOKS_BY_GATED_PLAN)
export const fetchPlaybooksByGatedPlanPending = createAction(constants.FETCH_PLAYBOOKS_BY_GATED_PLAN_PENDING)
export const fetchPlaybooksByGatedPlanFailed = createAction(constants.FETCH_PLAYBOOKS_BY_GATED_PLAN_FAILED)
export const fetchPlaybooksByGatedPlanCancelled = createAction(
  constants.FETCH_PLAYBOOKS_BY_GATED_PLAN_CANCELLED
)
export const fetchPlaybooksByGatedPlanSuccess = createAction(constants.FETCH_PLAYBOOKS_BY_GATED_PLAN_SUCCESS)

export const setEndUserEmail = createAction(constants.SET_END_USER_EMAIL)

export const asyncButtonPress = createAction(constants.ASYNC_BUTTON_PRESS)
export const asyncButtonPressPending = createAction(constants.ASYNC_BUTTON_PRESS_PENDING)
export const asyncButtonPressFailed = createAction(constants.ASYNC_BUTTON_PRESS_FAILED)
export const asyncButtonPressCancelled = createAction(constants.ASYNC_BUTTON_PRESS_CANCELLED)
export const asyncButtonPressSuccess = createAction(constants.ASYNC_BUTTON_PRESS_SUCCESS)

export const setEditSenderLevel = createAction(constants.SET_EDIT_SENDER_LEVEL)

export const setSignatureBody = createAction(constants.SET_SIGNATURE_BODY)
export const setSignatureIncludeAvatar = createAction(constants.SET_SIGNATURE_INCLUDE_AVATAR)
export const setSignatureIncludeSocial = createAction(constants.SET_SIGNATURE_INCLUDE_SOCIAL)
export const setSignatureIncludeBanner = createAction(constants.SET_SIGNATURE_INCLUDE_BANNER)
export const setSignatureBannerLinkURL = createAction(constants.SET_SIGNATURE_BANNER_LINK_URL)

export const setViewingSignatureId = createAction(constants.SET_VIEWING_SIGNATURE_ID)
export const addNewSignatureToPlaybook = createAction(constants.ADD_NEW_SIGNATURE_TO_PLAYBOOK)
export const removeSignature = createAction(constants.REMOVE_SIGNATURE)
export const addEmptyBannerSignature = createAction(constants.ADD_EMPTY_BANNER_SIGNATURE)
export const removeEmptyBannerSignature = createAction(constants.REMOVE_EMPTY_BANNER_SIGNATURE)

export const clearSignatureBanner = createAction(constants.CLEAR_SIGNATURE_BANNER)
export const setSignatureBanner = createAction(constants.SET_SIGNATURE_BANNER)
export const setSignatureBannerPending = createAction(constants.SET_SIGNATURE_BANNER_PENDING)
export const setSignatureBannerFailed = createAction(constants.SET_SIGNATURE_BANNER_FAILED)
export const setSignatureBannerCancelled = createAction(constants.SET_SIGNATURE_BANNER_CANCELLED)
export const setSignatureBannerSuccess = createAction(constants.SET_SIGNATURE_BANNER_SUCCESS)

export const fetchSignatureMultiBannerPreview = createAction(constants.FETCH_SIGNATURE_MULTI_BANNER_PREVIEW)
export const fetchSignatureMultiBannerPreviewPending = createAction(constants.FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_PENDING)
export const fetchSignatureMultiBannerPreviewFailed = createAction(constants.FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_FAILED)
export const fetchSignatureMultiBannerPreviewCancelled = createAction(constants.FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_CANCELLED)
export const fetchSignatureMultiBannerPreviewSuccess = createAction(constants.FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_SUCCESS)

export const createInitialWelcomePlaybooks = createAction(constants.CREATE_INITIAL_WELCOME_PLAYBOOKS)
export const createInitialWelcomePlaybooksPending = createAction(constants.CREATE_INITIAL_WELCOME_PLAYBOOKS_PENDING)
export const createInitialWelcomePlaybooksFailed = createAction(constants.CREATE_INITIAL_WELCOME_PLAYBOOKS_FAILED)
export const createInitialWelcomePlaybooksCancelled = createAction(constants.CREATE_INITIAL_WELCOME_PLAYBOOKS_CANCELLED)
export const createInitialWelcomePlaybooksSuccess = createAction(constants.CREATE_INITIAL_WELCOME_PLAYBOOKS_SUCCESS)

export const fetchPlaybookForCampaignId = createAction(constants.FETCH_PLAYBOOK_FOR_CAMPAIGN_ID)
export const fetchPlaybookForCampaignIdPending = createAction(constants.FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_PENDING)
export const fetchPlaybookForCampaignIdFailed = createAction(constants.FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_FAILED)
export const fetchPlaybookForCampaignIdCancelled = createAction(constants.FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_CANCELLED)
export const fetchPlaybookForCampaignIdSuccess = createAction(constants.FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_SUCCESS)

export const fetchPlaybooksByReportType = createAction(constants.FETCH_PLAYBOOKS_BY_REPORT_TYPE)
export const fetchPlaybooksByReportTypePending = createAction(constants.FETCH_PLAYBOOKS_BY_REPORT_TYPE_PENDING)
export const fetchPlaybooksByReportTypeFailed = createAction(constants.FETCH_PLAYBOOKS_BY_REPORT_TYPE_FAILED)
export const fetchPlaybooksByReportTypeCancelled = createAction(constants.FETCH_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED)
export const fetchPlaybooksByReportTypeSuccess = createAction(constants.FETCH_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS)

export const enableAllPlaybooksByReportType = createAction(constants.ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE)
export const enableAllPlaybooksByReportTypePending = createAction(constants.ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_PENDING)
export const enableAllPlaybooksByReportTypeFailed = createAction(constants.ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_FAILED)
export const enableAllPlaybooksByReportTypeCancelled = createAction(constants.ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED)
export const enableAllPlaybooksByReportTypeSuccess = createAction(constants.ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS)

export const fetchChatActivePlaybooks = createAction(constants.FETCH_CHAT_ACTIVE_PLAYBOOKS)

export const startReportTimer = createAction(constants.START_REPORT_TIMER)
export const incrementReportTimer = createAction(constants.INCREMENT_REPORT_TIMER)
export const decrementReportTimer = createAction(constants.DECREMENT_REPORT_TIMER)
export const recordedReportTimer = createAction(constants.RECORDED_REPORT_TIMER)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/playbook/actions.js